import { useState } from 'react';
import { BRAND_SHORT_NAME } from '../constants/brand.js';
import { clsx } from '../utils/cn.js';

const CANDIDATES = ['/logo.png', '/coonaltragas.png', '/coonaltragas.svg', '/coonaltragas.jpg', '/coonaltragas.webp'];

/**
 * Logo en `public/logo.png` (también se intentan variantes `coonaltragas.*`).
 */
export default function BrandLogo({ className, alt = BRAND_SHORT_NAME, eager = false }) {
  const [index, setIndex] = useState(0);

  return (
    <img
      src={CANDIDATES[index]}
      alt={alt}
      className={clsx('block object-contain object-left', className)}
      onError={() => {
        if (index < CANDIDATES.length - 1) setIndex((i) => i + 1);
      }}
      loading={eager ? 'eager' : 'lazy'}
      fetchpriority={eager ? 'high' : 'auto'}
      decoding="async"
    />
  );
}
